import blobticService from '../../Commun/services/blobticService';
import { PrjProject, PrjTask, PrjMilestone, PrjMember, PrjDashboardStats } from '../types/project';

export const mapProject = (dto: any): PrjProject => ({
  id: dto.PRJ_IDF,
  PRJ_IDF: dto.PRJ_IDF,
  PRJ_UIDF: dto.PRJ_UIDF,
  code: dto.PRJ_CODE || '',
  PRJ_CODE: dto.PRJ_CODE || '',
  title: dto.PRJ_TITLE || '',
  PRJ_TITLE: dto.PRJ_TITLE || '',
  client: dto.PRJ_CLIENT || '',
  PRJ_CLIENT: dto.PRJ_CLIENT || '',
  status: dto.PRJ_STATUS || 'PLANNING',
  PRJ_STATUS: dto.PRJ_STATUS || 'PLANNING',
  priority: dto.PRJ_PRIORITY || 'MEDIUM',
  PRJ_PRIORITY: dto.PRJ_PRIORITY || 'MEDIUM',
  startDate: dto.PRJ_START_DATE ? new Date(dto.PRJ_START_DATE).toISOString().split('T')[0] : '',
  PRJ_START_DATE: dto.PRJ_START_DATE,
  endDate: dto.PRJ_END_DATE ? new Date(dto.PRJ_END_DATE).toISOString().split('T')[0] : '',
  PRJ_END_DATE: dto.PRJ_END_DATE,
  budget: Number(dto.PRJ_BUDGET || 0),
  PRJ_BUDGET: Number(dto.PRJ_BUDGET || 0),
  spent: Number(dto.PRJ_SPENT || 0),
  PRJ_SPENT: Number(dto.PRJ_SPENT || 0),
  progress: Number(dto.PRJ_PROGRESS || 0),
  PRJ_PROGRESS: Number(dto.PRJ_PROGRESS || 0),
  manager: dto.PRJ_MANAGER || '',
  PRJ_MANAGER: dto.PRJ_MANAGER || '',
  description: dto.PRJ_DESCRIPTION || '',
  PRJ_DESCRIPTION: dto.PRJ_DESCRIPTION || '',
  dos_idf: dto.DOS_IDF ? Number(dto.DOS_IDF) : undefined,
  dos_code: dto.DOS_CODE,
  dos_lib: dto.DOS_LIB,
  user_lib: dto.USER_LIB,
  last_updt: dto.LAST_UPDT ? new Date(dto.LAST_UPDT).toLocaleString() : undefined,
});

export const mapTask = (dto: any): PrjTask => ({
  id: dto.PTK_IDF,
  PTK_IDF: dto.PTK_IDF,
  PTK_UIDF: dto.PTK_UIDF,
  code: dto.PTK_CODE || '',
  PTK_CODE: dto.PTK_CODE || '',
  projectId: Number(dto.PRJ_IDF || 0),
  PRJ_IDF: Number(dto.PRJ_IDF || 0),
  projectTitle: dto.PROJECT_TITLE || '',
  title: dto.PTK_TITLE || '',
  PTK_TITLE: dto.PTK_TITLE || '',
  status: dto.PTK_STATUS || 'TODO',
  PTK_STATUS: dto.PTK_STATUS || 'TODO',
  priority: dto.PTK_PRIORITY || 'MEDIUM',
  PTK_PRIORITY: dto.PTK_PRIORITY || 'MEDIUM',
  assignee: dto.PTK_ASSIGNEE || '',
  PTK_ASSIGNEE: dto.PTK_ASSIGNEE || '',
  dueDate: dto.PTK_DUE_DATE ? new Date(dto.PTK_DUE_DATE).toISOString().split('T')[0] : '',
  PTK_DUE_DATE: dto.PTK_DUE_DATE,
  estimatedHours: Number(dto.PTK_ESTIMATED_HOURS || 0),
  PTK_ESTIMATED_HOURS: Number(dto.PTK_ESTIMATED_HOURS || 0),
  actualHours: Number(dto.PTK_ACTUAL_HOURS || 0),
  PTK_ACTUAL_HOURS: Number(dto.PTK_ACTUAL_HOURS || 0),
  progress: Number(dto.PTK_PROGRESS || 0),
  PTK_PROGRESS: Number(dto.PTK_PROGRESS || 0),
  description: dto.PTK_DESCRIPTION || '',
  PTK_DESCRIPTION: dto.PTK_DESCRIPTION || '',
  dos_idf: dto.DOS_IDF ? Number(dto.DOS_IDF) : undefined,
  dos_code: dto.DOS_CODE,
  dos_lib: dto.DOS_LIB,
  user_lib: dto.USER_LIB,
  last_updt: dto.LAST_UPDT ? new Date(dto.LAST_UPDT).toLocaleString() : undefined,
});

export const mapMilestone = (dto: any): PrjMilestone => ({
  id: dto.PML_IDF,
  PML_IDF: dto.PML_IDF,
  PML_UIDF: dto.PML_UIDF,
  code: dto.PML_CODE || '',
  PML_CODE: dto.PML_CODE || '',
  projectId: Number(dto.PRJ_IDF || 0),
  PRJ_IDF: Number(dto.PRJ_IDF || 0),
  projectTitle: dto.PROJECT_TITLE || '',
  title: dto.PML_TITLE || '',
  PML_TITLE: dto.PML_TITLE || '',
  date: dto.PML_DATE ? new Date(dto.PML_DATE).toISOString().split('T')[0] : '',
  PML_DATE: dto.PML_DATE,
  status: dto.PML_STATUS || 'PENDING',
  PML_STATUS: dto.PML_STATUS || 'PENDING',
  description: dto.PML_DESCRIPTION || '',
  PML_DESCRIPTION: dto.PML_DESCRIPTION || '',
  dos_idf: dto.DOS_IDF ? Number(dto.DOS_IDF) : undefined,
  dos_code: dto.DOS_CODE,
  dos_lib: dto.DOS_LIB,
  user_lib: dto.USER_LIB,
  last_updt: dto.LAST_UPDT ? new Date(dto.LAST_UPDT).toLocaleString() : undefined,
});

export const mapMember = (dto: any): PrjMember => ({
  id: dto.PMB_IDF,
  PMB_IDF: dto.PMB_IDF,
  PMB_UIDF: dto.PMB_UIDF,
  code: dto.PMB_CODE || '',
  PMB_CODE: dto.PMB_CODE || '',
  projectId: Number(dto.PRJ_IDF || 0),
  PRJ_IDF: Number(dto.PRJ_IDF || 0),
  projectTitle: dto.PROJECT_TITLE || '',
  name: dto.PMB_NAME || '',
  PMB_NAME: dto.PMB_NAME || '',
  role: dto.PMB_ROLE || '',
  PMB_ROLE: dto.PMB_ROLE || '',
  email: dto.PMB_EMAIL || '',
  PMB_EMAIL: dto.PMB_EMAIL || '',
  allocation: Number(dto.PMB_ALLOCATION || 100),
  PMB_ALLOCATION: Number(dto.PMB_ALLOCATION || 100),
  dos_idf: dto.DOS_IDF ? Number(dto.DOS_IDF) : undefined,
  dos_code: dto.DOS_CODE,
  dos_lib: dto.DOS_LIB,
  user_lib: dto.USER_LIB,
  last_updt: dto.LAST_UPDT ? new Date(dto.LAST_UPDT).toLocaleString() : undefined,
});

export const projectApi = {
  // Projects
  async getProjects(): Promise<PrjProject[]> {
    const res = await blobticService.executeZoomRequest<any>({
      ZoomKey: 'prj_project',
      Action: { OKey: 'Blobtic_ProjectManagement,prj_project,select' }
    });
    return (res.success && Array.isArray(res.data)) ? res.data.map(mapProject) : [];
  },
  async insertProject(project: Partial<PrjProject> | any) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'prj_project',
      Action: {
        OKey: 'Blobtic_ProjectManagement,prj_project,insert',
        PRJ_CODE: project.code || project.PRJ_CODE || '',
        PRJ_TITLE: project.title || project.PRJ_TITLE || '',
        PRJ_DESCRIPTION: project.description || project.PRJ_DESCRIPTION || '',
        PRJ_STATUS: project.status || project.PRJ_STATUS || 'PLANNED',
        PRJ_PRIORITY: project.priority || project.PRJ_PRIORITY || 'MEDIUM',
        PRJ_PROGRESS: Number(project.progress ?? project.PRJ_PROGRESS ?? 0),
        PRJ_BUDGET: Number(project.budget ?? project.PRJ_BUDGET ?? 0),
        PRJ_SPENT: Number(project.spent ?? project.PRJ_SPENT ?? 0),
        PRJ_STARTDATE: project.startDate || project.PRJ_STARTDATE || '',
        PRJ_ENDDATE: project.endDate || project.PRJ_ENDDATE || '',
        PRJ_MANAGER: project.manager || project.PRJ_MANAGER || '',
        PRJ_CLIENT: project.client || project.PRJ_CLIENT || '',
      }
    });
  },
  async updateProject(project: Partial<PrjProject> | any) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'prj_project',
      Action: {
        OKey: 'Blobtic_ProjectManagement,prj_project,update',
        PRJ_IDF: project.id || project.PRJ_IDF,
        PRJ_CODE: project.code || project.PRJ_CODE,
        PRJ_TITLE: project.title || project.PRJ_TITLE,
        PRJ_DESCRIPTION: project.description || project.PRJ_DESCRIPTION,
        PRJ_STATUS: project.status || project.PRJ_STATUS,
        PRJ_PRIORITY: project.priority || project.PRJ_PRIORITY,
        PRJ_PROGRESS: Number(project.progress ?? project.PRJ_PROGRESS ?? 0),
        PRJ_BUDGET: Number(project.budget ?? project.PRJ_BUDGET ?? 0),
        PRJ_SPENT: Number(project.spent ?? project.PRJ_SPENT ?? 0),
        PRJ_STARTDATE: project.startDate || project.PRJ_STARTDATE,
        PRJ_ENDDATE: project.endDate || project.PRJ_ENDDATE,
        PRJ_MANAGER: project.manager || project.PRJ_MANAGER,
        PRJ_CLIENT: project.client || project.PRJ_CLIENT,
      }
    });
  },
  async deleteProject(id: number) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'prj_project',
      Action: {
        OKey: 'Blobtic_ProjectManagement,prj_project,delete',
        PRJ_IDF: id
      }
    });
  },

  // Tasks
  async getTasks(): Promise<PrjTask[]> {
    const res = await blobticService.executeZoomRequest<any>({
      ZoomKey: 'prj_task',
      Action: { OKey: 'Blobtic_ProjectManagement,prj_task,select' }
    });
    return (res.success && Array.isArray(res.data)) ? res.data.map(mapTask) : [];
  },
  async insertTask(task: Partial<PrjTask> | any) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'prj_task',
      Action: {
        OKey: 'Blobtic_ProjectManagement,prj_task,insert',
        PRJ_IDF: task.projectId || task.PRJ_IDF,
        PTK_CODE: task.code || task.PTK_CODE || '',
        PTK_TITLE: task.title || task.PTK_TITLE || '',
        PTK_DESCRIPTION: task.description || task.PTK_DESCRIPTION || '',
        PTK_STATUS: task.status || task.PTK_STATUS || 'TODO',
        PTK_PRIORITY: task.priority || task.PTK_PRIORITY || 'MEDIUM',
        PTK_PROGRESS: Number(task.progress ?? task.PTK_PROGRESS ?? 0),
        PTK_DUEDATE: task.dueDate || task.PTK_DUEDATE || '',
        PTK_ASSIGNEE: task.assignee || task.PTK_ASSIGNEE || '',
      }
    });
  },
  async updateTask(task: Partial<PrjTask> | any) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'prj_task',
      Action: {
        OKey: 'Blobtic_ProjectManagement,prj_task,update',
        PTK_IDF: task.id || task.PTK_IDF,
        PRJ_IDF: task.projectId || task.PRJ_IDF,
        PTK_CODE: task.code || task.PTK_CODE,
        PTK_TITLE: task.title || task.PTK_TITLE,
        PTK_DESCRIPTION: task.description || task.PTK_DESCRIPTION,
        PTK_STATUS: task.status || task.PTK_STATUS,
        PTK_PRIORITY: task.priority || task.PTK_PRIORITY,
        PTK_PROGRESS: Number(task.progress ?? task.PTK_PROGRESS ?? 0),
        PTK_DUEDATE: task.dueDate || task.PTK_DUEDATE,
        PTK_ASSIGNEE: task.assignee || task.PTK_ASSIGNEE,
      }
    });
  },
  async deleteTask(id: number) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'prj_task',
      Action: {
        OKey: 'Blobtic_ProjectManagement,prj_task,delete',
        PTK_IDF: id
      }
    });
  },

  // Milestones
  async getMilestones(): Promise<PrjMilestone[]> {
    const res = await blobticService.executeZoomRequest<any>({
      ZoomKey: 'prj_milestone',
      Action: { OKey: 'Blobtic_ProjectManagement,prj_milestone,select' }
    });
    return (res.success && Array.isArray(res.data)) ? res.data.map(mapMilestone) : [];
  },
  async insertMilestone(m: Partial<PrjMilestone> | any) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'prj_milestone',
      Action: {
        OKey: 'Blobtic_ProjectManagement,prj_milestone,insert',
        PRJ_IDF: m.projectId || m.PRJ_IDF,
        PML_CODE: m.code || m.PML_CODE || '',
        PML_TITLE: m.title || m.PML_TITLE || '',
        PML_DESCRIPTION: m.description || m.PML_DESCRIPTION || '',
        PML_DATE: m.date || m.PML_DATE || '',
        PML_STATUS: m.status || m.PML_STATUS || 'PENDING',
      }
    });
  },
  async updateMilestone(m: Partial<PrjMilestone> | any) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'prj_milestone',
      Action: {
        OKey: 'Blobtic_ProjectManagement,prj_milestone,update',
        PML_IDF: m.id || m.PML_IDF,
        PRJ_IDF: m.projectId || m.PRJ_IDF,
        PML_CODE: m.code || m.PML_CODE,
        PML_TITLE: m.title || m.PML_TITLE,
        PML_DESCRIPTION: m.description || m.PML_DESCRIPTION,
        PML_DATE: m.date || m.PML_DATE,
        PML_STATUS: m.status || m.PML_STATUS,
      }
    });
  },
  async deleteMilestone(id: number) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'prj_milestone',
      Action: {
        OKey: 'Blobtic_ProjectManagement,prj_milestone,delete',
        PML_IDF: id
      }
    });
  },

  // Members
  async getMembers(): Promise<PrjMember[]> {
    const res = await blobticService.executeZoomRequest<any>({
      ZoomKey: 'prj_member',
      Action: { OKey: 'Blobtic_ProjectManagement,prj_member,select' }
    });
    return (res.success && Array.isArray(res.data)) ? res.data.map(mapMember) : [];
  },
  async insertMember(mem: Partial<PrjMember> | any) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'prj_member',
      Action: {
        OKey: 'Blobtic_ProjectManagement,prj_member,insert',
        PRJ_IDF: mem.projectId || mem.PRJ_IDF,
        PMB_NAME: mem.name || mem.PMB_NAME || '',
        PMB_ROLE: mem.role || mem.PMB_ROLE || '',
        PMB_EMAIL: mem.email || mem.PMB_EMAIL || '',
        PMB_PHONE: mem.phone || mem.PMB_PHONE || '',
        PMB_ALLOCATION: Number(mem.allocation ?? mem.PMB_ALLOCATION ?? 100),
      }
    });
  },
  async updateMember(mem: Partial<PrjMember> | any) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'prj_member',
      Action: {
        OKey: 'Blobtic_ProjectManagement,prj_member,update',
        PMB_IDF: mem.id || mem.PMB_IDF,
        PRJ_IDF: mem.projectId || mem.PRJ_IDF,
        PMB_NAME: mem.name || mem.PMB_NAME,
        PMB_ROLE: mem.role || mem.PMB_ROLE,
        PMB_EMAIL: mem.email || mem.PMB_EMAIL,
        PMB_PHONE: mem.phone || mem.PMB_PHONE,
        PMB_ALLOCATION: Number(mem.allocation ?? mem.PMB_ALLOCATION ?? 100),
      }
    });
  },
  async deleteMember(id: number) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'prj_member',
      Action: {
        OKey: 'Blobtic_ProjectManagement,prj_member,delete',
        PMB_IDF: id
      }
    });
  },

  // Dashboard
  async getDashboardStats(): Promise<PrjDashboardStats> {
    const res = await blobticService.executeZoomRequest<any>({
      ZoomKey: 'prj_dashboard',
      Action: { OKey: 'Blobtic_ProjectManagement,prj_dashboard,select' }
    });
    if (res.success && res.data) {
      const d = Array.isArray(res.data) ? res.data[0] : res.data;
      return {
        totalProjects: Number(d?.totalProjects || 0),
        activeProjects: Number(d?.activeProjects || 0),
        totalTasks: Number(d?.totalTasks || 0),
        doneTasks: Number(d?.doneTasks || 0),
        overdueTasks: Number(d?.overdueTasks || 0),
        totalBudget: Number(d?.totalBudget || 0),
        totalSpent: Number(d?.totalSpent || 0),
        pendingMilestones: Number(d?.pendingMilestones || 0),
      };
    }
    return {
      totalProjects: 0,
      activeProjects: 0,
      totalTasks: 0,
      doneTasks: 0,
      overdueTasks: 0,
      totalBudget: 0,
      totalSpent: 0,
      pendingMilestones: 0,
    };
  }
};
